module.exports = __webpack_public_path__ + "img/step-2@2x.5cd5c297.png";